import React from "react";
import { FlexCol } from "components-shared/Layout";
import { i18n, useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { Icon, Select } from "ui-kit";
import Colors from "ui-kit/colors";
import { FlexRow } from "ui-kit/Layout/Flex";
import { getSelectablePaymentDays } from "utils/site";
import { nthNumberByLocale } from "utils/utils";
import PaymentInfo from "./Payment/PaymentInfo";
import { BillingInterval } from "utils/insurance";

type ChoosePaymentDayProps = {
  value: number;
  billingInterval: BillingInterval;
  onChange: (value: number) => void;
  smallTitle?: boolean;
};

const ChoosePaymentDay = ({
  value,
  billingInterval,
  onChange,
  smallTitle,
}: ChoosePaymentDayProps) => {
  const { t } = useWebTranslation();

  const selectablePaymentDays = getSelectablePaymentDays() ?? [];
  const hasSelecablePaymentDays = !!selectablePaymentDays.length;

  const items = selectablePaymentDays.map((day) => ({
    label: nthNumberByLocale({ number: day, locale: i18n?.language }),
    value: day,
  }));
  const item = items.find((i) => i.value === value);

  return hasSelecablePaymentDays ? (
    <FlexCol>
      {smallTitle ? (
        <Typography color="grey500">
          <strong>{t("global.payment_day")}</strong>
        </Typography>
      ) : (
        <Typography variant="h3" color="grey500">
          {t("global.payment_day")}
        </Typography>
      )}
      <Gutter size={3} />
      <FlexRow
        alignItems="center"
        style={{
          border: `1px solid ${Colors.grey200}`,
          borderRadius: 16,
          padding: "8px 6px 8px 16px",
        }}
      >
        <Select<{ label?: string; value: number }>
          label={t("global.payment_day")}
          onSelectedItemChange={({ selectedItem }) =>
            selectedItem && onChange(selectedItem.value)
          }
          items={items}
          itemToString={(item) => item?.label ?? ""}
          defaultSelectedItem={item}
          icon={<Icon name="calendar" size="M" />}
        />
      </FlexRow>
      <Gutter size={1} />
      <Typography variant="body3" color="grey500">
        {t("global.payment_day_description")}
      </Typography>
    </FlexCol>
  ) : (
    <PaymentInfo billingInterval={billingInterval} />
  );
};

export default ChoosePaymentDay;
